import { BaseAPI } from './base';
import { ExportTask } from '../../types/entity/export-task';

export class ExportTaskAPI extends BaseAPI<ExportTask> {
  constructor() {
    super('/export-tasks');
  }
}

export const exportTaskApi = new ExportTaskAPI();
export default exportTaskApi;
